import { render, staticRenderFns } from "./categoriesManager.vue?vue&type=template&id=4fda6520&scoped=true&"
import script from "./categoriesManager.vue?vue&type=script&lang=js&"
export * from "./categoriesManager.vue?vue&type=script&lang=js&"
import style0 from "./categoriesManager.vue?vue&type=style&index=0&id=4fda6520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fda6520",
  null
  
)

export default component.exports